/***
*
*   canResendVerification
*   Whether the resend-invite control should be offered for a verification.
*
*   Extracted as a pure function (like nav-bar-items.js) so the gate is
*   testable without mounting the 900-line detail view.
*
**********/

// api_sms verifications are delivered by SMS and are allowed to carry no email
// at all -- model/verification.js waives email validation for that trigger.
const SMS_ONLY_TRIGGER = "api_sms";

export function canResendVerification({ canCancel, verificationInfo }) {
  if (!canCancel) return false;

  // Active only. A Tranche 2 awaiting staff review sits at active:false with
  // consent, intake and biometric already complete, so re-sending the invite
  // would push the client back into a finished flow. Cancel is still useful
  // there; a fresh link is not.
  if (!verificationInfo?.active) return false;

  return verificationInfo?.triggered_by !== SMS_ONLY_TRIGGER;
}
